import { BrandfolderHexColors } from '../enums/colors.js';

const defaultPopout = {
    backgroundColor: BrandfolderHexColors.White,
    borderColor: BrandfolderHexColors.White,
    footerBackgroundColor: BrandfolderHexColors.DirtyMarshmallowHalf,
    footerBorderColor: BrandfolderHexColors.DirtyMarshmallowHalf,
    headerBorderColor: BrandfolderHexColors.Gray,
    textColor: BrandfolderHexColors.Text
};
const primaryPopout = {
    backgroundColor: BrandfolderHexColors.PurplePopsicle,
    borderColor: BrandfolderHexColors.PurplePopsicle,
    footerBackgroundColor: BrandfolderHexColors.PurplePopsicle,
    footerBorderColor: BrandfolderHexColors.White,
    headerBorderColor: BrandfolderHexColors.White,
    textColor: BrandfolderHexColors.White
};

export { defaultPopout, primaryPopout };
//# sourceMappingURL=popout.js.map
